"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ['overall_rating', 'submitted_by', 'no_review_content'];
exports.default = _default;